import { useEffect, useState } from "react";
import { unitType } from "../../../util/unitType";
import { toast } from "react-toastify";
import { reformatData } from "../../../util/helperFunctions";
import { getModelPlotData } from "../../model/util/modelUtils";
import { fetchExpressions } from "../../../api/sensorApi";
import moment from 'moment';

const features = [
    {
        id: "CC_Temperature",
        name: "Temperature",
    },
    {
        id: "Dew_Point",
        name: "Dew Point",
    }
];


const getTemperatureData = async (id, start, end, units) => {
    console.log(id, start, end, units)
    const dew_spec = {
        subject_filter: `sensor.id = '${id}'`,
        start: start,
        end: end,
        expressions: ["Dew_Point", "CC_Temperature"],
        units: [unitType(units, 'temperature'), unitType(units, 'temperature')],
        interval: "H",
    }


    try {
        const res = await fetchExpressions("SensorExpression", dew_spec);
        var formatted_data = reformatData([res])
        return formatted_data;
    } catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return [];
    }
}


function useGetTempDewPointChartData(id, start, end, units, site) {
    // console.log(id, tag_id, start, end, units, site)
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        async function fetchData() {
            if (id && site && start && end) {
                setLoading(true);
                try {
                    
                    // Fetch temperature data
                    const tempData = await getTemperatureData(id, start, end, units);
                    if (tempData.length > 0) {
                        console.log(tempData[0]);
                        // Fetch temperature flags
                        const formattedData = getModelPlotData(tempData[0], features, units, id);

                        setData([...formattedData]);
                    } else {
                        toast.error("No temperature and dew point temperature data found for the specified ID.");
                    }
                }
                catch (error) {
                    console.error("Error fetching temperature data:", error);
                    toast.error("Error fetching temperature data. Please try again later.");
                } finally {
                    setLoading(false);
                }

            }
        }
        fetchData();

    }, [id, start, end, units, site]);

    return { data, loading }
}

export default useGetTempDewPointChartData;